var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGermany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7342_284060)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 14,
    rx: 1,
    fill: "#1A47B8"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_7342_284060)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 14,
    rx: 1,
    fill: "#F93939"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9.625H20.9091V14H0V9.625Z",
    fill: "#FFDA2C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H20.9091V4.375H0V0Z",
    fill: "#151515"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7342_284060"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 14,
    rx: 1,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_7342_284060"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 14,
    rx: 1,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGermany);
export default __webpack_public_path__ + "static/media/germany.5e128a5dc40c11f4646ea985cfd6ffd6.svg";
export { ForwardRef as ReactComponent };